import { Type } from "class-transformer";
import ResponseEntity, { InputEntity } from "../../..";
import {
  IsArray,
  IsInt,
  IsNumber,
  IsString,
  ValidateIf,
  ValidateNested,
} from "class-validator";
import TransmedFormSubsection from "./subsection";

export default class TransmedFormSection extends ResponseEntity {
  @IsInt() public readonly id!: number;
  @IsString() public readonly title!: string;
  @IsInt() public readonly weight!: number;

  @ValidateIf((obj) => obj.proportional !== null)
  @IsNumber()
  public readonly proportional!: number | null;

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => TransmedFormSubsection)
  public readonly subsections!: TransmedFormSubsection[];
}

export class TransmedFormSectionInput extends InputEntity {
  public constructor(
    public readonly title: string,
    public readonly weight: number,
    public readonly proportional: number | null
  ) {
    super();
  }
}
